import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupConfig from "./routes/YearGroupConfig";
import YearGroupStudents from "./routes/YearGroupStudents";
import TranscriptHistory from "./routes/TranscriptHistory";
export default store => ({
  path: ":yeargroup_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    YearGroupConfig(store),
    YearGroupStudents(store),
    TranscriptHistory(store),
  ],
});
